import React, { PureComponent } from "react";
import moment from "moment-timezone";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { numberWithCommas, intToRGB, hashCode, getSentimentColor } from "../../Dashboard/Charts/utils";
import HighchartsCustomEvents from "highcharts-custom-events";

HighchartsCustomEvents(Highcharts);

class EngagementModalChart extends PureComponent {
    chartComponent = React.createRef();
    state = {};

    componentDidMount() {
        this.ro = new ResizeObserver(() => {
            setTimeout(() => {
                this.chartComponent?.current?.chart.setSize(null, null);
                this.chartComponent?.current?.chart.reflow();
            }, 0);
        });
    }

    componentWillUnmount() {
        this.ro.disconnect();
    }

    // componentDidUpdate(prevProps) {
    //     if (this.props.resizedCount !== prevProps.resizedCount) {
    //         this.chartComponent.current.chart.setSize(null, null);
    //         this.chartComponent.current.chart.reflow();
    //     }
    // }

    getOptions = () => {
        //  let data = data.chartData;

        let self = this;
        let tz = JSON.parse(localStorage.company).user_timezone_name;
        let tzo = JSON.parse(localStorage.company).user_timezone * -60;

        let data = this.props.data && JSON.parse(JSON.stringify(this.props.data));
        let serObj = [
            {
                name: "Total",
                data: data?.total,
                color: getSentimentColor("total"),
            },
            {
                name: "Comments",
                data: data?.comment_count,
                color: intToRGB(hashCode("comment")),
            },
            {
                name: "Likes",
                data: data?.like_count,
                color: intToRGB(hashCode("like")),
            },
            {
                name: "Shares",
                data: data?.share_count,
                color: intToRGB(hashCode("share")),
            },
            {
                name: "Views",
                data: data?.view_count,
                color: intToRGB(hashCode("views")),
            },
        ];
        console.log("firsjkjjkjkkjjkt", serObj);

        const optionsOverTime = {
            chart: {
                className: "skiptranslate",
                type: "spline",
                backgroundColor: "transparent",
                // spacingTop: 0,
                // spacingBottom: 0,
                // spacingLeft: 0,
                // spacingRight: 0,
                style: {
                    fontFamily: "'Roboto', sans-serif",
                    fontSize: 12,
                },
            },
            credits: {
                enabled: false,
            },
            title: {
                text: " ",
            },
            legend: {
                // enabled: this.props.showLegend,
            },
            xAxis: {
                type: "datetime",
                dateTimeLabelFormats: {
                    millisecond: "%l:%M %p",
                    second: "%l:%M %p",
                    minute: "%l:%M %p",
                    hour: "%l:%M %p",
                    day: "%e %b",
                    week: "%e. %b",
                    month: "%b '%y",
                    year: "%Y",
                },
                labels: {
                    style: {
                        textTransform: "normal",
                    },
                },
            },
            yAxis: {
                // gridLineWidth: this.props.showGridLines ? 2 : 0,
                // gridLineDashStyle: "ShortDash",
                // gridLineColor: "#ccd6eb",
                lineColor: "#ccd6eb",
                lineWidth: 1,
                title: " ",
            },
            series: serObj,
            plotOptions: {
                series: {
                    marker: {
                        symbol: "circle",
                        radius: 4,
                    },
                    events: {
                        // legendItemClick: function () {
                        //     self.props.legendClick(true);
                        // },
                    },
                    // {
                    //     symbol: "triangle-down",
                    //     radius: 4,
                    // },
                    // ],
                },
                spline: {
                    point: {
                        // events: {
                        //     contextmenu: function (e) {
                        //         e.preventDefault();
                        //         self.props.addContextMenuListener(e.x, e.y, Object.assign({}, this));
                        //     },
                        // },
                    },
                },
            },
            time: {
                timezoneOffset: tzo,
            },
            tooltip: {
                followPointer: true,
                followTouchMove: true,
                // shared: plotComaprisiondata ? true : false,
                // outside: true,
                className: "skiptranslate",
                // crosshairs: true,
                useHTML: true,
                formatter: function () {
                    return `${moment(this.x).tz(tz).format("LLLL")}<br/>${this.point?.series?.name}: <b>${numberWithCommas(this.y)}</b>`;
                },
                backgroundColor: "#fff",
                borderRadius: 6,
                // style:{
                //     zIndex:9999999999,

                // },
            },
        };

        return optionsOverTime;
    };

    render() {
        return (
            <HighchartsReact
                highcharts={Highcharts}
                options={this.getOptions()}
                ref={this.chartComponent}
                containerProps={{ style: { width: "100%", height: "100%" } }}
            />
        );
    }
}

export default EngagementModalChart;
